import React, { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";

import useCRUD from "../../hooks/useCRUD";

import { formatDateWithDay } from "../../utils/dateUtils";
import Spinner from "../Spinner/Spinner";
import Pagination from "../Elements/Pagination";

const EVENTS_PER_PAGE = 4;

export default function UpcomingEvents() {
  const [currentPage, setCurrentPage] = useState(1);
  const {
    data: allEvents = [], // Provide an empty array as a default value
    isLoading,
    fetchItems: getEvents,
  } = useCRUD("/api/events");

  useEffect(() => {
    console.log("Fetching events...");
    getEvents().catch((err) => {
      console.log("Error fetching events:", err);
    });
  }, [getEvents]);

  const today = new Date();
  const nextWeek = new Date();
  nextWeek.setDate(today.getDate() + 7);

  const events = allEvents
    ?.filter((event) => {
      const eventDate = new Date(event.dateOfOccurrence);
      return eventDate >= today && eventDate <= nextWeek;
    })
    .sort(
      (a, b) => new Date(a.dateOfOccurrence) - new Date(b.dateOfOccurrence),
    );

  const totalPages = Math.max(
    1,
    Math.ceil((events?.length || 0) / EVENTS_PER_PAGE),
  );
  const page = Math.min(currentPage, totalPages);
  const pagedEvents = events?.slice(
    (page - 1) * EVENTS_PER_PAGE,
    page * EVENTS_PER_PAGE,
  );

  if (isLoading) {
    return <Spinner />;
  }
  if (!events || events.length === 0) {
    return (
      <div className="card bg-white shadow-lg mx-auto p-6 rounded-xl">
        <h2 className="text-xl font-black text-gray-900 mb-2">
          No Upcoming Events This Week
        </h2>
        <p className="text-gray-600">
          There are no upcoming events scheduled for this week. Go to the Events
          tab to view all events.
        </p>
      </div>
    );
  }
  return (
    <div className="card bg-white shadow-lg mx-auto p-5 sm:p-6 rounded-xl">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-[#004a7e]">
            This week
          </p>
          <h2 className="text-xl font-black text-gray-900 sm:text-2xl">
            Upcoming Events
          </h2>
        </div>
        <span className="rounded-md bg-[#eaf3fa] px-3 py-1 text-xs font-bold text-[#004a7e]">
          {events.length} total
        </span>
      </div>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {pagedEvents.map((event) => (
          <div
            key={event.id}
            className="rounded-lg border border-gray-100 bg-gray-50 p-4 cursor-pointer transition hover:border-[#cfe2f0] hover:bg-[#f5fbff]"
            onClick={() => (window.location.href = `/event/manage/${event.id}`)}
          >
            <div className="flex items-start gap-3">
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-[#004a7e] text-white">
                <FontAwesomeIcon icon={faCalendarAlt} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-base font-bold text-gray-900 truncate">
                  {event.title}
                </p>
                <p className="text-sm text-gray-500 truncate">
                  {event.location}
                </p>
                <div className="mt-2 flex">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold bg-green-50 text-success">
                    <FontAwesomeIcon
                      icon={faCalendar}
                      className="mr-2 h-4 w-4 text-green-600"
                    />
                    {formatDateWithDay(event.dateOfOccurrence)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Pagination
        currentPage={page}
        totalItems={events.length}
        itemsPerPage={EVENTS_PER_PAGE}
        onPageChange={setCurrentPage}
        label="events"
      />
    </div>
  );
}
